import { ApiService } from "./api.service";

export class SignUpService {  
  
  
  async sendEmailOtp({ email, password, isRegister }: any) {
    return new Promise((resolve, reject) => {
      const request = {
       email,
       password,
       isRegister
      };
      ApiService.post("Account/send-email-otp", JSON.stringify(request))
        .then((result) => {
          if (result) {
            resolve(result);
          } else {
            reject(result);
          }
        })
        .catch((err: any) => {
          reject(err);
        });
    });
  }
  
  register({ name, email, password, otp, companyName, contactNumber, roleId }: any) {
    const request = {
      Name: name,
      Email: email,
      Password: password,
      OTP: otp,
    } as any;
    // include optional/required fields if provided
    if (companyName) request.CompanyName = companyName;
    if (contactNumber) request.ContactNumber = contactNumber;
    if (roleId) request.RoleId = Number(roleId);

    return ApiService.post("user/SelfRegisterUser", JSON.stringify(request));
  }
}
